import React from 'react';
import styled from 'styled-components';
import { Palette } from 'core/config';

interface CardProps 
{
    height? : number;
    css?    : string;
    className?: string;
}

export const Card : React.FunctionComponent<CardProps> = ({ 
    height, 
    css = '',
    children,
    className
}) =>
{
    return (
        <RootContainer>
            <Container height={height} css={css} className={className}>
                {children}
            </Container>
        </RootContainer>
    );
};

const RootContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Container = styled.div<CardProps>`
    position: relative;
    margin-top: 116px;
    background-color: ${Palette.TAN};
    border-radius: 22px;
    min-height: ${({ height }) => height ? height : 520}px;
    width: 419px;

    @media only screen and (min-width: 1300px) {
        min-width: 427px;
    }

    ${({ css }) => css && css}
`;